import { render, staticRenderFns } from "./veJkyGainCount.vue?vue&type=template&id=317e988c&scoped=true"
import script from "./veJkyGainCount.vue?vue&type=script&lang=js"
export * from "./veJkyGainCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317e988c",
  null
  
)

export default component.exports